import { api } from '@api/api2';
import type { SearchPeoplePayload } from './types';

export const searchPeople = (payload: SearchPeoplePayload) =>
  api.v1('get', 'crm/userdata/list', payload);
